import { useCallback, useContext, useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import GenericTable from '../table/GenericTable'
import { ReportingContext } from '../../../../../wrappers/ReportingContext'
import { OrderByColumnsContext } from './OrderByColumnsContext'
import { useEffect } from 'react'
import EmptyTitleHeader from '../table/TitleHeader'
import { convertReactSelectObjectToValue } from '../../../../../../utils/reporting/config'

const OrderByAvailableColumns = [
    {
        Header: 'In SELECT?',
        accessor: 'inSelect',
        Cell: ({ row: { original } }) => {
            return original.inSelect
        },
    },
    {
        Header: 'Source.Column',
        accessor: 'sourceColumn',
        Cell: ({ value }) => {
            return (
                value && (
                    <span>
                        {value.split('.')[0]}.<b>{value.split('.')[1]}</b>
                    </span>
                )
            )
        },
    },
    {
        Header: 'Column Type',
        accessor: 'columnType',
        Cell: ({ value }) => {
            return value
        },
    },
]

const OrderByAvailableColumnsTable = () => {
    const { reportSelectOptions, reportConfig } = useContext(ReportingContext)
    const {
        leftTableHighlights,
        setLeftTableHighlights,
        setLeftTableData,
        setRightTableData,
        rightTableData,
    } = useContext(OrderByColumnsContext)

    const handleFilteredRowsChange = useCallback(
        (rowsInfo) => {
            setLeftTableData(rowsInfo.filteredRows)
        },
        [setLeftTableData]
    )

    const selectedDataSourceColumns = useMemo(
        () =>
            reportSelectOptions
                ? reportSelectOptions.selectedDataSourceColumns
                : [],
        [reportSelectOptions]
    )
    const selectedDataSources = useMemo(() => {
        return reportSelectOptions && reportSelectOptions.selectedDataSources
            ? reportSelectOptions.selectedDataSources
            : []
    }, [reportSelectOptions])

    const columnsInSelect = useMemo(() => {
        return reportConfig && reportConfig.columns
            ? reportConfig.columns.map((c) => c.sourceColumn)
            : []
    }, [reportConfig])

    const fields = useMemo(() => {
        const fieldList = []
        const rightTableSourceColumns = rightTableData.map(
            (item) => item.sourceColumn
        )

        selectedDataSources.forEach((selectedSource) => {
            const fieldGroup = selectedDataSourceColumns
                .filter((col) => col.TABLE_NAME === selectedSource.value)
                .filter((col) => {
                    //hides the columns that are included in the right table
                    const sourceColumn = `${col.TABLE_NAME}.${col.COLUMN_NAME}`
                    return !rightTableSourceColumns.includes(sourceColumn)
                })
                .map((col, i) => {
                    const tableName = selectedSource.alias || col.TABLE_NAME
                    //CHARACTER_MAXIMUM_LENGTH = MAX is represented as -1 in DB
                    const inSelectValue =
                        columnsInSelect.length === 0 ||
                        columnsInSelect.includes(
                            `${tableName}.${col.COLUMN_NAME}`
                        )
                            ? 'Yes'
                            : 'No'

                    return {
                        id: `${tableName}.${col.COLUMN_NAME}[${i}]`,
                        inSelect: inSelectValue,
                        sourceColumn: `${tableName}.${col.COLUMN_NAME}`,
                        columnType: col.DATA_TYPE_DISPLAY,
                    }
                })
            fieldList.push(...fieldGroup)
        })
        return fieldList
    }, [
        selectedDataSourceColumns,
        columnsInSelect,
        selectedDataSources,
        rightTableData,
    ])
    // const fields = useMemo(() => {
    //     const rightTableSourceColumns = rightTableData.map(
    //         (item) => item.sourceColumn
    //     )
    //     return selectedDataSourceColumns
    //         .filter((x) =>
    //             selectedDataSources.some(
    //                 (selected) =>
    //                     convertReactSelectObjectToValue(selected) ===
    //                     x.TABLE_NAME
    //             )
    //         ) //filter available columns by the joined tables and primary data source
    //         .filter((col) => {
    //             //hides the columns that are included in the right table
    //             const sourceColumn = `${col.TABLE_NAME}.${col.COLUMN_NAME}`
    //             return !rightTableSourceColumns.includes(sourceColumn)
    //         })
    //         .map((col, i) => {
    //             //CHARACTER_MAXIMUM_LENGTH = MAX is represented as -1 in DB
    //             return {
    //                 id: `${col.TABLE_NAME}[${i}]`,
    //                 inSelect:
    //                     columnsInSelect.length === 0 ||
    //                     columnsInSelect.includes(
    //                         `${col.TABLE_NAME}.${col.COLUMN_NAME}`
    //                     )
    //                         ? 'Yes'
    //                         : 'No',
    //                 sourceColumn: `${col.TABLE_NAME}.${col.COLUMN_NAME}`,
    //                 columnType: col.DATA_TYPE_DISPLAY,
    //             }
    //         })
    // }, [
    //     selectedDataSourceColumns,
    //     columnsInSelect,
    //     selectedDataSources,
    //     rightTableData,
    // ])

    useEffect(() => {
        setLeftTableData(fields)
    }, [fields, setLeftTableData, setRightTableData])

    return fields && fields.length ? (
        <GenericTable
            columns={OrderByAvailableColumns}
            fields={fields}
            tableHeight={'68vh'}
            tableTile={'Available Columns'}
            viewOnly={false}
            onHightlight={setLeftTableHighlights}
            highlightedRows={leftTableHighlights}
            filterable={true}
            onFilteredRowsChange={handleFilteredRowsChange}
        />
    ) : (
        <EmptyTitleHeader fields={fields} tableTile={'Available Columns'} />
    )
}

export default OrderByAvailableColumnsTable
